export default __webpack_public_path__ + "static/media/Home.1c6abc2a.svg";